// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2IZbS","title":"Header_title__uety-","side":"Header_side__2n_HF"};